import apiClient from '../services/apiClient';

export default {
	namespaced: true,
	state: {
		init: false,
		deliveryOptions: {},
	},
	getters: {
		deliveryOptions(state) {
			return state.deliveryOptions;
		},
	},
	mutations: {
		SET_SHIPPINGOPTIONS(state, deliveryOptions) {
			state.deliveryOptions = deliveryOptions
		},
		SET_INIT(state, init) {
			state.init = init
		},
		CLEAR_STORE(state) {
			state.init = false;
			state.deliveryOptions = {};
		}
	},
	actions: {
		init({commit, state}) {
			return new Promise((resolve, reject) => {
				if (state.init) {
					resolve();
				} else {
					apiClient.get('settings/shippingmethods/get').then(res => {
						commit('SET_SHIPPINGOPTIONS', res.data);
						commit('SET_INIT', true);
						resolve();
					}).catch(err => {
						reject(err);
					})
				}
			})
		},
		updateShippingoptions({commit}, selectedShippingoptions) {
			return new Promise((resolve, reject) => {
				apiClient.put('settings/shippingmethods/update', selectedShippingoptions).then(res => {
					commit('SET_SHIPPINGOPTIONS', res.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
